import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Table } from 'react-bootstrap';
import ScrollAnimation from 'react-animate-on-scroll';
import './Achieve.scss'
import parse from 'html-react-parser';
import moment from 'moment';
import DateFormat from "../../format-auction-date";

// markup

const Achieve = (props) => {

    const [upcommingActions, setUpcomingActions] = useState([]);
    const handleTime = (dataD) => {
        let data= new Date(dataD)
        let hrs = data.getHours()
        let mins = data.getMinutes()
        if(hrs<=9)
           hrs = '0' + hrs
        if(mins<10)
          mins = '0' + mins
        const postTime= hrs + ':' + mins
        return postTime
      }

      useEffect(()=>{
        let auctionList = [];
        props.upcomingauctions.map((auction) => {
            let auctionDate = moment(auction.Auction_Date).add(12, 'hours'); 
            if(!moment().isSameOrAfter(auctionDate)){ 
                auctionList.push(auction);
            }
        }) 
        let sortedActions = auctionList.sort((a,b) => moment(a.Auction_Date).valueOf() - moment(b.Auction_Date).valueOf());
        setUpcomingActions(sortedActions)
      
      }, [props])


      
    return (
        <React.Fragment>
            <section className="achieve auctions-achieve">
                
                    <Container>
                        <Row>
                            <Col className="d-lg-flex justify-content-between">
                                <div className="achieve-details">
                                    {parse(props.leftcontent)}                                    
                                </div>
                                <div className="auctions-wrapper">
                                    {/* {upcommingActions?.length > 0 &&
                                     <div className="next-auction">
                                        <h2>Next Auction</h2>
                                        <ul className="times d-flex justify-content-between">                                            
                                            <li><DateFormat date={upcommingActions[0].Auction_Date}/></li>
                                            <li className="d-flex align-items-start"><i className="icon-clock"></i>
                                            {handleTime(upcommingActions[0].Auction_Date)}
                                            </li>
                                        </ul>
                                        <a target="_blank" className="sm-text" href={upcommingActions[0].Auction_Catalog_Link}>Online Auction</a>
                                        <a target="_blank" className="btn btn-primary" href={upcommingActions[0].Auction_Catalog_Link}>View lots</a>
                                    </div>
                                    }  */}
                                    {/* <div className="bottom-content">
                                        <h2>Upcoming Auctions</h2>
                                        <ul className="days d-flex justify-content-between">
                                            {upcommingActions && upcommingActions.map((auction, i) => {
                                                if( i >= 1){
                                                    return(
                                                        <>
                                                            <li>
                                                            <DateFormat weekday="short" month="short" date={auction.Auction_Date}/> {handleTime(auction.Auction_Date)}
                                                            </li>
                                                            <li>
                                                            <a href={auction.Auction_Catalog_Link} target="_blank">View Catalog</a>
                                                            </li>
                                                        </>
                                                    )
                                                } 
                                            })}
                                            
                                        </ul>
                                    </div> */}
                                     <div className="bottom-content">
                                       <iframe 
                                        src="https://www.networkauctions.co.uk/auctions/future-auctions/"
                                          className="future-actions"
                                          style={{ height: '100%',width:'100%' }}                            
                                          title="Future Auctions">
                                      </iframe>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                
            </section>
        </React.Fragment >
    )
}
export default Achieve

